const STORAGE_KEY = 'bg_workbench_prefs'

const DEFAULTS = {
  activeService: 'AIGC',
  activeLanguage: '中文',
  activePlatform: '',
  inputMode: 'text'
}

const SERVICES = ['AIGC', 'DEDUP', 'DUAL', 'POLISH']
const LANGUAGES = ['中文', '英文']
const PLATFORMS = ['Turnitin', '知网', '维普', '格子达', '大雅', '万方']
const INPUT_MODES = ['text', 'file']

function normalizePrefs(prefs) {
  const result = { ...DEFAULTS }
  if (!prefs || typeof prefs !== 'object') {
    return result
  }
  if (SERVICES.includes(prefs.activeService)) {
    result.activeService = prefs.activeService
  }
  if (LANGUAGES.includes(prefs.activeLanguage)) {
    result.activeLanguage = prefs.activeLanguage
  }
  if (!prefs.activePlatform || PLATFORMS.includes(prefs.activePlatform)) {
    result.activePlatform = prefs.activePlatform || ''
  }
  if (INPUT_MODES.includes(prefs.inputMode)) {
    result.inputMode = prefs.inputMode
  }
  return result
}

export function loadWorkbenchPrefs() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return { ...DEFAULTS }
    }
    return normalizePrefs(JSON.parse(raw))
  } catch (e) {
    return { ...DEFAULTS }
  }
}

export function saveWorkbenchPrefs(prefs) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizePrefs(prefs)))
}
